export default "__VITE_PUBLIC_ASSET__194a1729__"